<markant-button colorScheme="primary" variant="clear" (click)="isOpen = true">
  <markant-icon icon="m_group-large-delete" slot="icon-leading"></markant-icon>
  {{ 'dashboardOverview.groupAssignment.detail.deleteGroup' | transloco }}
</markant-button>

<markant-platform-modal-bridge *ngIf="isOpen">
  <markant-dialog
    class="group-delete-dialog"
    [headTitle]="
      'dashboardOverview.groupAssignment.deleteDialog.headline' | transloco
    "
    [open]="true"
    (close)="isOpen = false"
  >
    <span class="body">{{
      'dashboardOverview.groupAssignment.deleteDialog.text' | transloco
    }}</span>
    <div slot="footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        [loading]="isLoading"
        (click)="isOpen = false"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
      <markant-button
        colorScheme="primary"
        [loading]="isLoading"
        (click)="onDelete()"
      >
        {{ 'common.delete' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
